"use client";
import { isEmpty, sortBy, merge, keyBy, values } from "lodash";

import IconMeasurement from "@/components/Icon/IconMeasurement.svg";

import Image from "next/image";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { setSelectVariantKlaviyoEvent } from "@/lib/klaviyo/events";

export default function SizeSelector({
  product,
  variants,
  selectedVariant,
  saleorVariants,
  setShowSizeGuideDialog = () => {},
  setSelectedVariant = () => {},
  setInventories = () => {},
  className,
}) {
  const { sizeData, listVariantsMerged } = getData(variants, saleorVariants);

  const sizeHandleSelector = variant => {
    const currentSku = variant.sku;
    const currentVariant = listVariantsMerged.find(v => v.sku === currentSku);
    if (currentVariant) {
      setSelectedVariant(currentVariant);
      setInventories(currentVariant.inventories);
      setSelectVariantKlaviyoEvent(product, currentVariant);
    }
  };

  return (
    sizeData &&
    sizeData.length > 0 &&
    sizeData.filter(variant => variant.attributeValue).length > 0 && (
      <div className={classNames(className)}>
        <div className="flex justify-between items-center">
          <label className="text-sm font-bold font-roboto">Select size:</label>
          <div
            className="px-3 py-1 flex items-center justify-center gap-2  border-[1px] border-grey cursor-pointer rounded-full"
            onClick={() => setShowSizeGuideDialog(true)}
          >
            <Image src={IconMeasurement.src} width="16" height="16" alt="measurement" />
            <span className="text-xs font-bold pt-[2px]">SIZE GUIDE</span>
          </div>
        </div>
        <div className="flex flex-wrap mt-[10px] gap-2">
          {sizeData &&
            sizeData.map((variant, index) => (
              <button
                key={`size-${index}`}
                className={classNames("w-[43px] h-10  border-[1px] rounded-sm relative", {
                  "bg-black text-white": selectedVariant && selectedVariant?.objectID === variant.objectID,
                  "border-grey opacity-40": variant.quantityAvailable < 1 || !variant.isPublished,
                  "border-black cursor-pointer": !(variant.quantityAvailable < 1 || !variant.isPublished),
                })}
                disabled={variant.quantityAvailable < 1 || !variant.isPublished}
                onClick={() => sizeHandleSelector(variant)}
              >
                {variant.attributeValue}
                {(variant.quantityAvailable < 1 || !variant.isPublished) && (
                  <div className={classNames(styles.line)}></div>
                )}
              </button>
            ))}
        </div>
      </div>
    )
  );
}
const sortedVariants = _list => {
  const list = [..._list];
  return sortBy(list, "sku");
};

export const getData = (variants, saleorVariants) => {
  if (isEmpty(variants) && isEmpty(saleorVariants)) return {};
  const newVariants = [...variants];
  const newSaleorVariants = [...saleorVariants];
  //Merged two variants list from two source
  const merged = merge(keyBy(newVariants, "sku"), keyBy(newSaleorVariants, "sku"));
  //Check if variant product not has attributeValue field, then map it
  const _merged = values(merged).map(variant => {
    if (!variant.attributeValue) {
      const sizeAttribute = variant.attributes.find(
        ({ attribute }) => attribute.name === "Sizes" || attribute.name === "Helmet Sizing"
      );
      variant.attributeValue = sizeAttribute?.values[0]?.name || variant.name;
    }
    return variant;
  });
  const _sorted = sortedVariants(values(merged));
  return {
    listVariantsMerged: _merged,
    sizeData: _sorted,
  };
};
